document.addEventListener('DOMContentLoaded', function () {
  var customiseButton = document.getElementById('customise-button');

  if (customiseButton) {
    customiseButton.addEventListener('click', function () {
      var productHandle = customiseButton.getAttribute('data-product-handle'); // Get product handle from data attribute
      var customizeUrl = '/pages/customize?product=' + productHandle; // Use correct URL structure for Shopify page
      window.open(customizeUrl, '_blank'); // Open the URL in a new tab
    });
  }
});
